import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Converte entrada numérica que pode vir em formato BR (vírgula decimal,
 * ponto de milhar — "1.234,56", "18,38") ou ponto decimal ("467.23") para
 * número. Retorna `null` para vazio/inválido — NUNCA NaN, pois NaN é
 * serializado como `null` pelo JSON.stringify e perde o dado silenciosamente.
 *
 * Regra de separador: se houver vírgula, ela é o decimal e os pontos são
 * milhar; sem vírgula, o ponto (se houver) é o decimal.
 */
export function parseDecimalBR(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null
  if (typeof value === 'number') return Number.isFinite(value) ? value : null
  const cleaned = String(value).trim().replace(/[^0-9,.-]/g, '')
  if (cleaned === '' || cleaned === '-') return null
  const normalized = cleaned.includes(',')
    ? cleaned.replace(/\./g, '').replace(',', '.')
    : cleaned
  const n = parseFloat(normalized)
  return Number.isFinite(n) ? n : null
}
